import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../components/Layout/MainLayout';

const NotFoundPage: React.FC = () => {
  return (
    <MainLayout>
      <div className="flex flex-col items-center justify-center h-[60vh] px-4">
        <h1 className="text-9xl font-bold text-secondary">404</h1>
        <h2 className="text-4xl font-bold text-primary mt-4">Page Not Found</h2>
        <p className="text-lg text-primary mt-2 text-center">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Link
          to="/"
          className="mt-8 px-6 py-3 bg-secondary text-white rounded-md hover:bg-secondaryDark transition-colors"
        >
          Back to Products
        </Link>
      </div>
    </MainLayout>
  );
};

export default NotFoundPage;
